import { DATA_SERVICE_BASE_URL } from './ApiService'; // ✅ FIXED: Import base URL from ApiService

// ✅ FIXED: Use the same base URL with proxy path appended
export const AI_SERVICE_BASE_URL = `${DATA_SERVICE_BASE_URL}/api/proxy/ai-service`;
export const AI_STREAMING_SERVICE_BASE_URL = `${DATA_SERVICE_BASE_URL}/api/proxy/ai-service-stream`;

// use this when running Ai Service locally without proxy
// export const AI_SERVICE_BASE_URL = 'http://localhost:8080';

/**
 * AI API Service Configuration
 * 
 * This file provides centralized configuration for all AI services.
 * 
 * The AI service is accessed through a proxy on the main data service:
 * - Main API: https://hibernate-service-491484225296.us-central1.run.app
 * - AI Proxy: https://hibernate-service-491484225296.us-central1.run.app/api/proxy/ai-service
 * 
 * Individual API modules should be imported directly from their source files:
 * 
 * import { AiDocumentProcessingApi } from '../services/ai/AiDocumentProcessingApi';
 * import { AiConversationsApi } from '../services/ai/AiConversationsApi';
 * import { AiHealthApi } from '../services/ai/AiHealthApi';
 * import { AiUtilsApi } from '../services/ai/AiUtilsApi';
 * import { AiStudyGenerationApi } from '../services/ai/AiStudyGenerationApi';
 * import { AiAudioGenerationApi } from '../services/ai/AiAudioGenerationApi';
 * 
 * Configuration:
 * - AI_SERVICE_BASE_URL: Centralized base URL for all AI service API calls (proxied through main service)
 * - Uses same authentication as main API service
 * 
 * Usage Examples:
 * const fullResult = await AiDocumentProcessingApi.processDocumentFull(docId, { documentTypeId: 1 });
 * const syllabus = await AiDocumentProcessingApi.processDocumentAsSyllabus(docId, { courseName: 'ML Course' });
 * const aiResponse = await AiConversationsApi.promptSimple('Hello');
 * const quizResult = await AiStudyGenerationApi.generateQuiz({ document_ids: [1, 2], num_questions: 10, user_id: 1 });
 * const audioResult = await AiAudioGenerationApi.generateAudio({ document_ids: [1], format: 'podcast', user_id: 1 });
 * 
 * // Access base URL if needed
 * console.log('AI Service Base URL:', AI_SERVICE_BASE_URL);
 * // Output: https://hibernate-service-491484225296.us-central1.run.app/api/proxy/ai-service
 */

// Legacy export for backward compatibility - DEPRECATED
export const AiApi = {
  // Health & Monitoring
  checkHealth: () => { throw new Error('Use AiHealthApi.checkHealth() instead'); },
  isServiceAvailable: () => { throw new Error('Use AiHealthApi.isServiceAvailable() instead'); },
  getServiceInfo: () => { throw new Error('Use AiHealthApi.getServiceInfo() instead'); },
  getBaseUrl: () => { throw new Error('Use AiHealthApi.getBaseUrl() instead'); },
  
  // Document Processing (legacy proxy stubs)
  processDocumentFull: () => { throw new Error('Use AiDocumentProcessingApi.processDocumentFull() instead'); },
  processDocumentAsSyllabus: () => { throw new Error('Use AiDocumentProcessingApi.processDocumentAsSyllabus() instead'); },
  
  // File Operations
  uploadDocument: () => { throw new Error('Use AiFileApi.uploadDocument() instead'); },
  
  // Chat & Conversations
  promptSimple: () => { throw new Error('Use AiConversationsApi.promptSimple() instead'); },
  promptWithConversationContext: () => { throw new Error('Use AiConversationsApi.promptWithConversationContext() instead'); },
  continueConversation: () => { throw new Error('Use AiConversationsApi.continueConversation() instead'); },
  chatGeneral: () => { throw new Error('Use AiConversationsApi.chatGeneral() instead'); },
  chatWithDocuments: () => { throw new Error('Use AiConversationsApi.chatWithDocuments() instead'); },
  
  // Utilities
  handleResponse: () => { throw new Error('Use AiUtilsApi.handleResponse() instead'); },
  safeApiCall: () => { throw new Error('Use AiUtilsApi.safeApiCall() instead'); }
};

export default AiApi;
